const toggleReorderButton = document.querySelector('.product-info__reorder-button');

if (toggleReorderButton) {
  const LIST_NAME = 'Reorder Pad';
  const ADD_LABEL = 'Add to Reorder Pad';
  const REMOVE_LABEL = 'Remove from Reorder Pad';

  let lid = null;
  let reorderList = null;
  let isProductInList = false;
  let swatInstance = null;

  function getProduct() {
    return {
      epi: +toggleReorderButton.dataset.variantId,
      empi: +toggleReorderButton.dataset.productId,
      du: toggleReorderButton.dataset.productUrl,
    };
  }

  function updateButtonState(inList) {
    isProductInList = inList;
    toggleReorderButton.textContent = inList ? REMOVE_LABEL : ADD_LABEL;
    toggleReorderButton.classList.toggle('swym-added', inList);
  }

  function checkProductInList() {
    if (!reorderList?.listcontents) {
      updateButtonState(false);
      return;
    }

    const product = getProduct();
    updateButtonState(reorderList.listcontents.some(el => el.epi === product.epi));
  }

  function syncListState(lists) {
    reorderList = lists.find(list => list.lname === LIST_NAME);
    lid = reorderList?.lid || null;
    checkProductInList();
    return lid;
  }

  function createList(swat) {
    return new Promise((resolve) => {
      swat.createList(
        { lname: LIST_NAME },
        (list) => {
          if (list?.lid) {
            lid = list.lid;
            reorderList = list;
          }
          resolve(lid);
        },
        (error) => {
          console.log('Error while creating reorder pad', error);
          resolve(null);
        }
      );
    });
  }

  async function ensureList(swat) {
    if (lid) return lid;

    return new Promise((resolve) => {
      swat.fetchLists({
        callbackFn: async (lists) => {
          syncListState(lists);
          if (!lid) {
            await createList(swat);
          }
          resolve(lid);
        },
        errorFn: (error) => {
          console.log('Error while fetching all Lists', error);
          resolve(null);
        }
      });
    });
  }

  function refreshListState() {
    if (!swatInstance) return;

    swatInstance.fetchLists({
      callbackFn: (lists) => syncListState(lists),
      errorFn: (error) => {
        console.log('Error while fetching all Lists', error);
        updateButtonState(false);
      }
    });
  }

  function onSwymLoadCallback(swat) {
    if (!swat) return;
    swatInstance = swat;
    ensureList(swat);
  }

  toggleReorderButton.addEventListener('click', async function() {
    if (!swatInstance) return;

    const listId = await ensureList(swatInstance);
    if (!listId) return;

    const product = getProduct();
    toggleReorderButton.disabled = true;

    if (isProductInList) {
      swatInstance.deleteFromList(
        listId,
        product,
        () => {
          updateButtonState(false);
          if (reorderList?.listcontents) {
            reorderList.listcontents = reorderList.listcontents.filter(el => el.epi !== product.epi);
          }
          toggleReorderButton.disabled = false;
        },
        (error) => {
          console.log('Error while removing product from reorder list', error);
          toggleReorderButton.disabled = false;
        }
      );
    } else {
      swatInstance.addToList(
        listId,
        product,
        () => {
          updateButtonState(true);
          if (reorderList && Array.isArray(reorderList.listcontents)) {
            reorderList.listcontents.push(product);
          }
          toggleReorderButton.disabled = false;
        },
        (error) => {
          console.log('Error while adding product to reorder list', error);
          toggleReorderButton.disabled = false;
        }
      );
    }
  });

  const mutationCallback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type !== 'attributes' ||
        mutation.attributeName !== 'data-variant-id'
      ) {
        return;
      }
      refreshListState();
    }
  };

  const observer = new MutationObserver(mutationCallback);
  observer.observe(toggleReorderButton, { attributes: true });

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
}
